/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    reservation: PropTypes.object.isRequired,
    pActions: PropTypes.object.isRequired,
};

export default class CommentBox extends React.Component {
    handleChange({ target }) {
        const { value } = target;
        this.props.pActions.updatePendingReservation(
            this.props.reservation.id,
            'comment',
            value
        );
    }

    render() {
        const { id } = this.props.reservation;
        const { showCommentBox } = this.props;

        if (!showCommentBox) return <></>;

        return (
            <div className="permit-vehicle-wrap">
                <label
                    htmlFor={`${id}-comments text-area-1`}
                    className="form-section-header"
                >
                    <h1 className="form-section-header">Comments</h1>
                </label>
                <p>
                    Add any important notes, prior experiences or special instructions for
                    your trip.
                </p>
                <textarea
                    rows="3"
                    id={`${id}-comments text-area-1`}
                    placeholder="Enter your comments here..."
                    value={this.props.reservation.comment}
                    onChange={(e) => {
                        this.handleChange(e);
                    }}
                />
            </div>
        );
    }
}

CommentBox.propTypes = propTypes;
